"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENDER_MODES = exports.ONE_DAY = exports.FOUR_HOURS = exports.ONE_HOUR = exports.DEFAULT_REVALIDATE_SECONDS = exports.EVENT_TRACKING_APP_KEY = exports.META_DEFAULT_BASE_URL = void 0;
exports.META_DEFAULT_BASE_URL = 'https://www.udemy.com';
exports.EVENT_TRACKING_APP_KEY = 'web_main';
exports.DEFAULT_REVALIDATE_SECONDS = 60 * 30; // 30 minutes
exports.ONE_HOUR = 60 * 60;
exports.FOUR_HOURS = exports.ONE_HOUR * 4;
exports.ONE_DAY = exports.ONE_HOUR * 24;
exports.RENDER_MODES = {
    // Client side rendered
    CSR: 'CSR',
    // Incremental static rendered
    ISR: 'ISR',
    // Server side generated
    SSG: 'SSG',
    // Server side rendered
    SSR: 'SSR',
};
//# sourceMappingURL=constants.js.map